module.exports = __webpack_public_path__ + "static/media/account.4c4f9079.svg";